import React, { ReactNode } from "react";

import ChatContext from "@app/util/contexts/ChatContext";
import useHiddenChat from "@app/util/useHiddenChat";

interface Props {
  children: ReactNode;
}

const HideChat: React.FC<Props> = ({ children }) => {
  // hide Help button and then keep hiding it for all children
  useHiddenChat();
  return <ChatContext.Provider value={true}>{children}</ChatContext.Provider>;
};

export default HideChat;
